import { EEnvCountry } from 'affiny-core/env.types';
import { EBrand, EHostLang } from 'affiny-core/types/env.types';
import { overrideConfig, sharedConfigProd } from './shared-config';

export const getProdConfig = (
  brand: EBrand,
  hostLang: EHostLang,
  country: EEnvCountry
) => {
  return {
    cookies: {
      domains: [
        domainsProdCookies[`${country}_DOMAIN`],
        domainsProdCookies[`LEGACY_${country}_DOMAIN`],
        domainsProdCookies[`DOT_${country}_DOMAIN]`],
      ],
      // This default domain will be used to set cookies on a specific domain
      // For now it is only useful for the remenc
      defaultDomain: domainsProdCookies[`DOT_${country}_DOMAIN]`],
    },
    credentials: {
      sentryDSN: 'https://516453c2e1a149ff8e6a79e7e7bfd66e@sentry.io/1405907',
      algoliaApiKey: 'fa80da6e29168564e6c5960518a4646e',
      algoliaAppId: 'plYG601EXJGU',
    },
    ...sharedConfigProd,
    ...overrideConfig(brand, hostLang),
  };
};

const domainsProdCookies = {
  // These different domains need to be considered because
  // when you come from a CRM mail, 3 remencs are set
  FR_DOMAIN: '.affiny.fr',
  // this domain is considered legacy,
  // it has to be removed once the aventador team will use DOT_FR_DOMAIN for the cookies domain
  LEGACY_FR_DOMAIN: 'www.affiny.fr',
  DOT_FR_DOMAIN: '.www.affiny.fr',

  UK_DOMAIN: '.affiny.co.uk',
  LEGACY_UK_DOMAIN: 'www.affiny.co.uk',
  DOT_UK_DOMAIN: '.www.affiny.co.uk',

  NL_DOMAIN: '.lexamore.nl',
  LEGACY_NL_DOMAIN: 'www.lexamore.nl',
  DOT_NL_DOMAIN: '.www.lexamore.nl',

  NO_DOMAIN: '.matchaffinity.no',
  LEGACY_NO_DOMAIN: 'www.matchaffinity.no',
  DOT_NO_DOMAIN: '.www.matchaffinity.no',

  SE_DOMAIN: '.matchaffinity.se',
  LEGACY_SE_DOMAIN: 'www.matchaffinity.se',
  DOT_SE_DOMAIN: '.www.matchaffinity.se',

  DK_DOMAIN: '.matchaffinity.dk',
  LEGACY_DK_DOMAIN: 'www.matchaffinity.dk',
  DOT_DK_DOMAIN: '.www.matchaffinity.dk',

  FI_DOMAIN: '.matchaffinity.fi',
  LEGACY_FI_DOMAIN: 'www.matchaffinity.fi',
  DOT_FI_DOMAIN: '.www.matchaffinity.fi',

  IE_DOMAIN: '.matchaffinity.ie',
  LEGACY_IE_DOMAIN: 'www.matchaffinity.ie',
  DOT_IE_DOMAIN: '.www.matchaffinity.ie',

  IT_DOMAIN: '.meeticaffinity.it',
  LEGACY_IT_DOMAIN: 'www.meeticaffinity.it',
  DOT_IT_DOMAIN: '.www.meeticaffinity.it',

  ES_DOMAIN: '.meeticaffinity.es',
  LEGACY_ES_DOMAIN: 'www.meeticaffinity.es',
  DOT_ES_DOMAIN: '.www.meeticaffinity.es',

  PT_DOMAIN: '.meeticaffinity.pt',
  LEGACY_PT_DOMAIN: 'beta.meeticaffinity.pt',
  DOT_PT_DOMAIN: '.beta.meeticaffinity.pt',

  BE_DOMAIN: '.meeticaffinity.be',
  LEGACY_BE_DOMAIN: 'fr.meeticaffinity.be',
  DOT_BE_DOMAIN: '.fr.meeticaffinity.be',

  CHF_DOMAIN: '.meeticaffinity.ch',
  LEGACY_CHF_DOMAIN: 'fr.meeticaffinity.ch',
  DOT_CHF_DOMAIN: '.fr.meeticaffinity.ch',

  DE_DOMAIN: '.partner.de',
  LEGACY_DE_DOMAIN: 'www.partner.de',
  DOT_DE_DOMAIN: '.www.partner.de',

  CHG_DOMAIN: '.partner.ch',
  LEGACY_CHG_DOMAIN: 'www.partner.ch',
  DOT_CHG_DOMAIN: '.www.partner.ch',
};
